import { getTimeInSeconds } from '../../../media-lifecycle-hooks/utils';
import { ExtendedBrightcovePlayer } from '../../../types';

const INITIAL_CONSUMDED_SECONDS = 0;

/**
 * IMPORTANT: "consumed second" != current media position. Thus, the user cannot scroll to the end of the video to "consume" the whole entirely.
 * Implication: Imagine a user is watching a 20 minute video. With the current algorithm he can watch the first 5 minutes 4 times to "consume" the entire video.
 * An alternative can be to use hashmap to track not only the amount of the consumed seconds, but also to be sure that all video content is consumed.
 * */

// In the plugin we extends methods of the player so we need to do type casting
// Perhaps there is another, more elegant way
export function consumedSecondsPlugin(this: object) {
  const playerInstance = this as ExtendedBrightcovePlayer;
  let consumedSeconds = INITIAL_CONSUMDED_SECONDS;

  let lastSavedTimeInSeconds = -1;

  const timeupdateHandler = () => {
    const currentTimeInSec = getTimeInSeconds(playerInstance);
    if (lastSavedTimeInSeconds !== currentTimeInSec) {
      lastSavedTimeInSeconds = currentTimeInSec;
      consumedSeconds++;
      playerInstance.trigger('secondconsumed', { seconds: consumedSeconds });
    }
  };
  const cleanupState = () => {
    consumedSeconds = INITIAL_CONSUMDED_SECONDS;
  };

  playerInstance.on('timeupdate', timeupdateHandler);

  // clean up consumed seconds when src has changed
  playerInstance.on('loadedmetadata', cleanupState);

  playerInstance.consumedSeconds = () => {
    return consumedSeconds;
  };
}
